import React, { useState, useEffect } from "react";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import Button from "@mui/material/Button";
import PaperAirplaneIcon from "@heroicons/react/24/solid/PaperAirplaneIcon";
import XMarkIcon from "@heroicons/react/24/solid/XMarkIcon";
import UserService from "../../services/UserService";
import CircularProgress from "@mui/material/CircularProgress";

import { Alert, AlertTitle, TextField, Stack, Box, SvgIcon } from "@mui/material";
import { toast } from "react-toastify";

const FormDialog = ({ item, handleClose, refresh }) => {
  const [loading, setLoading] = useState(false);
  const [form, setForm] = useState({
    firstname: "",
    lastname: "",
    email: "",
    password: "",
  });
  const [errors, setErrors] = useState({});
  const [error, setError] = useState("");
  const [info, setInfo] = useState("");

  useEffect(() => {
    if (item) {
      setForm({
        id: item.id,
        firstname: item.firstname || "",
        lastname: item.lastname || "",
        email: item.email || "",
        password: "",
      });
    }
  }, [item]);

  const changeFormAttribute = (name, value) => {
    setForm((prevForm) => ({
      ...prevForm,
      [name]: value,
    }));
  };

  const save = async () => {
    setLoading(true);
    setError("");
    setInfo("");

    try {
      await UserService.update(item.id, form);
      refresh();
      handleClose();
      toast.success("L'utilisateur a été mis à jour avec succès");
    } catch (e) {
      setError("Une erreur s'est produite");
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      {item && (
        <Dialog
          open={true}
          onClose={handleClose}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
          fullWidth
          maxWidth="md"
        >
          <DialogTitle id="alert-dialog-title" sx={{ alignItems: "center" }}>
            Mise à jour d'un membre
          </DialogTitle>
          <DialogContent sx={{ justifyContent: "center" }}>
            <DialogContentText id="alert-dialog-description">
              {error && (
                <Alert severity="error" variant="filled" sx={{ mb: 2 }}>
                  <AlertTitle>Erreur</AlertTitle>
                  {error}
                </Alert>
              )}

              {info && (
                <Alert severity="success" variant="filled" sx={{ mb: 2, color: "#fff" }}>
                  <AlertTitle>Succès</AlertTitle>
                  {info}
                </Alert>
              )}

              <form
                noValidate
                onSubmit={(e) => {
                  e.preventDefault();
                  save();
                }}
              >
                <Stack
                  spacing={3}
                  sx={{
                    "& .MuiInputBase-input": {
                      background: "#f1f1f1",
                    },
                    mt: 3,
                  }}
                >
                  <TextField
                    error={Boolean(errors.firstname)}
                    fullWidth
                    helperText={errors.firstname}
                    label="Nom"
                    name="firstname"
                    onBlur={() => {}}
                    onChange={(e) => changeFormAttribute("firstname", e.target.value)}
                    type="text"
                    value={form.firstname}
                  />

                  <TextField
                    error={Boolean(errors.lastname)}
                    fullWidth
                    helperText={errors.lastname}
                    label="Prénom"
                    name="lastname"
                    onBlur={() => {}}
                    onChange={(e) => changeFormAttribute("lastname", e.target.value)}
                    type="text"
                    value={form.lastname}
                  />

                  <TextField
                    error={Boolean(errors.email)}
                    fullWidth
                    helperText={errors.email}
                    label="Email Address"
                    name="email"
                    onBlur={() => {}}
                    onChange={(e) => changeFormAttribute("email", e.target.value)}
                    type="email"
                    value={form.email}
                  />

                  <TextField
                    error={Boolean(errors.password)}
                    variant="filled"
                    fullWidth
                    helperText={errors.password}
                    label="Mot de passe"
                    name="password"
                    onBlur={() => {}}
                    onChange={(e) => changeFormAttribute("password", e.target.value)}
                    type="password"
                    value={form.password}
                  />
                </Stack>
                <Box sx={{ display: "flex", justifyContent: "center", mt: 4, mb: 1 }}>
                  <Button
                    startIcon={
                      <SvgIcon fontSize="small">
                        <XMarkIcon />
                      </SvgIcon>
                    }
                    sx={{ mt: 3, mr: 3 }}
                    variant="contained"
                    onClick={handleClose}
                  >
                    Annuler
                  </Button>
                  <Button
                    disabled={loading}
                    startIcon={
                      <SvgIcon fontSize="small">
                        <PaperAirplaneIcon />
                      </SvgIcon>
                    }
                    sx={{ mt: 3 }}
                    variant="contained"
                    onClick={save}
                  >
                    {loading ? <CircularProgress size={24} /> : "Sauvegarder"}
                  </Button>
                </Box>
              </form>
            </DialogContentText>
          </DialogContent>
        </Dialog>
      )}
    </>
  );
};

export default FormDialog;
